import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../Firebase/Firebase';
import NewsItem from './NewsItem';

const NewsList = () => {
    const [news, setNews] = useState([]);

    useEffect(() => {
        const fetchNews = async () => {
            const querySnapshot = await getDocs(collection(db, 'news'));
            const newsData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setNews(newsData);
        };

        fetchNews();
    }, []);

    return (
        <div>
            {news.map(item => (
                <NewsItem key={item.id} newsItem={item} />
            ))}
        </div>
    );
};

export default NewsList;
